<h1 mat-dialog-title class="mbp-confirm-dialog__title">{{ dialogTitle }}</h1>

<div mat-dialog-content class="mbp-confirm-dialog__content order-item-details-dialog__content">
  @if (batchItems.length) {
    <div class="order-item-details-dialog__table-wrap mbp-table-wrap">
      <table
        mat-table
        [dataSource]="batchItems"
        class="mbp-data-table order-item-details-dialog__table"
      >
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef>#</th>
          <td mat-cell *matCellDef="let item">{{ item.id }}</td>
        </ng-container>

        <ng-container matColumnDef="barcode">
          <th mat-header-cell *matHeaderCellDef>Barcode</th>
          <td mat-cell *matCellDef="let item">
            {{ item.barcode ? item.barcode : '—' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="medicine_number">
          <th mat-header-cell *matHeaderCellDef>Medicine number</th>
          <td mat-cell *matCellDef="let item">{{ medicineNumber }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  } @else {
    <p class="order-item-details-dialog__empty">No batch items recorded for this medicine yet.</p>
  }
</div>

<div mat-dialog-actions align="end" class="mbp-confirm-dialog__actions">
  <button mat-flat-button color="primary" (click)="closeDialog()" cdkFocusInitial>
    Close
  </button>
</div>
